import { i18n } from '$lib/i18n';

export const reroute = i18n.reroute();
